import {MODULE_NAME} from "./slice";

export const selectListItem = (state) => state[MODULE_NAME].userList;
export const selectCurrentUser = (state) => state[MODULE_NAME].user;
export const selectFlagDelete = (state) => state[MODULE_NAME].flag_delete;
